var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRules = function SvgRules(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.069 18.842h-4.937L47.4 26.575v4.937l7.733 7.733h4.937l7.733-7.733v-4.937l-7.733-7.733ZM35.314 54.174l-3.492-3.493h-10.94l-3.492 3.493v10.94l3.492 3.492h10.94l3.492-3.492v-10.94Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.742,
    cy: 59.644,
    r: 9.257,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.314 59.644h14.182M50.982 35.264 33.161 53.087M45.9 66.442l5.062-5.062v-3.232L45.9 53.086",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgRules;